import {IRenderContext, RenderContext} from './RenderContext';
import {FixedScale, Scale} from './Scale';

	export enum Position {
		TOP,
		LEFT,
		BOTTOM,
		RIGHT
	}

	export class AxesConfiguration {
		public xAxes: Axis[] = [];
		public yAxes: Axis[] = [];

		public constructor(axes: Axis[]){
			axes.forEach(axis => {
				if(axis.position == Position.BOTTOM ||
					axis.position == Position.TOP) {
						this.xAxes.push(axis);
				}
				else if(axis.position == Position.LEFT ||
					axis.position == Position.RIGHT) {
						this.yAxes.push(axis);
				}
			});
		}

		public scale(context: RenderContext) {
			this.xAxes.forEach(axis => {
				axis.calculateScale(context);
			});
			this.yAxes.forEach(axis => {
				axis.calculateScale(context);
			});
		}
	}

	export class Axis {
		public minimum: number = 0;
		public maximum: number = 100;
		public scaleFactor: number = 1;
		public position: Position;
		public scaleType: Scale = new FixedScale(this.minimum, this.maximum);

		public constructor(scaleType: Scale) {
			this.scaleType = scaleType;
		}

		public calculateScale(context: RenderContext) {
			var scale = this.scaleType.scale(this, context);
			if(isFinite(scale.min)) {
				this.minimum = scale.min;
			}
			if(isFinite(scale.max)) {
				this.maximum = scale.max;
			}
			if(isFinite(scale.scaleFactor)) {
				this.scaleFactor = scale.scaleFactor;
			}
		}

		}

		export class TimelineAxis extends Axis {

		public constructor(scaleType: Scale) {
			super(scaleType);
			this.position = Position.BOTTOM;
			this.scaleType = scaleType;
		}

		public setStartTime(timestamp: number) {
			var displayPeriod = this.getDisplayPeriod();
			this.minimum = timestamp;
			this.maximum = timestamp + displayPeriod;
		}

		public setEndTime(timestamp: number) {
			var displayPeriod = this.getDisplayPeriod();
			this.minimum = timestamp - displayPeriod;
			this.maximum = timestamp;
		}

		public getDisplayPeriod(): number {
			return this.maximum - this.minimum;
		}

		public setDisplayPeriod(period: number) {
			this.maximum = this.minimum + period;
		}

		}

		export class NumericAxis extends Axis {

		public unitOfMeasure = "";

		public constructor(scaleType: Scale) {
			super(scaleType);
			this.position = Position.LEFT;
		}
	}
